module.exports = __webpack_public_path__ + "static/media/animal-spotting.d4c12f35.png";